import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import { LookupMesaExamen } from '../MesaExamen/LookupMesaExamen';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { InscripcionExamenErrorMessage } from './InscripcionExamenErrorMessage';

const CONDICION_OPTIONS = [
  { value: 'Regular', label: 'Regular' },
  { value: 'Libre', label: 'Libre' },
  { value: 'Equivalencia', label: 'Equivalencia' },
];

const DEFAULT_CONDICION = CONDICION_OPTIONS[0];

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddInscripcionExamen extends Component {
  static displayName = AddInscripcionExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      showCursada: false,
      alumno: { codigo: '', descripcion: '' },
      carreraCursada: -1,
      tagData: [{ id: '', text: '', materiaCarreraCod3: '', condicion: DEFAULT_CONDICION }],
      ignorarCorrelatividad: false,
      ignorarRegularidad: false,
      ignorarDosDias: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWInscripcionExamen');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleCondicionTagChange = (tagId, option) => {
    this.clearFeedback();
    this.setState({
      tagData: this.state.tagData.map((tag) => (
        tag.id === tagId ? { ...tag, condicion: option } : tag
      )),
    });
  };

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleShowCursadaLookup = () => {
    if (!this.state.loading && this.state.carreraCursada !== -1) {
      this.setState({ showCursada: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupAnios: false,
      carreraCursada: Number(carreraProperties[3]),
      alumno: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2],
      },
    });
  };

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = {
      id: carreraProperties[0],
      text: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[4].trim() + ' - ' + carreraProperties[5].trim() + ' - ' + carreraProperties[3].trim(),
      materiaCarreraCod3: carreraProperties[6],
      condicion: DEFAULT_CONDICION,
    };
    const tagData = this.state.tagData;
    tagData.push(tag);
    this.clearFeedback();
    this.setState({
      showCursada: false,
      tagData,
    });
  };

  handleDelete = (i) => {
    this.clearFeedback();
    this.setState({
      tagData: this.state.tagData.filter((tag) => tag.id !== i),
    });
  };

  handleCheckBoxCorrelatividad = (e) => {
    this.clearFeedback();
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  handleCheckBoxRegularidad = (e) => {
    this.clearFeedback();
    this.setState({ ignorarRegularidad: e.target.checked });
  };

  handleCheckBoxDosDias = (e) => {
    this.clearFeedback();
    this.setState({ ignorarDosDias: e.target.checked });
  };

  isOkToSave() {
    const tags = this.state.tagData.slice(1);
    return this.state.alumno.descripcion.length > 1
      && tags.length > 0
      && tags.every((tag) => tag.condicion && tag.condicion.value);
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios' });
      return;
    }

    this.saveStudent();
  }

  renderMesaTags() {
    const tagData = this.state.tagData.slice(1);
    if (tagData.length === 0) {
      return <p className="md-form-page__empty-hint">Ninguna mesa de examen seleccionada</p>;
    }
    return (
      <ul className="md-form-page__tags md-form-page__tags--stack">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-form-page__tag md-form-page__tag--stacked">
            <span className="md-form-page__tag-label">{tag.text}</span>
            <div className="md-form-page__tag-select">
              <Select
                inputId={'ie-condicion-' + tag.id}
                classNamePrefix="md-form-page__select"
                classNames={SELECT_CLASS_NAMES}
                value={tag.condicion || DEFAULT_CONDICION}
                options={CONDICION_OPTIONS}
                onChange={(option) => this.handleCondicionTagChange(tag.id, option)}
                isDisabled={this.state.loading}
                aria-label={'Condición para ' + tag.text}
              />
            </div>
            <button
              type="button"
              className="md-form-page__tag-remove"
              onClick={() => this.handleDelete(tag.id)}
              disabled={this.state.loading}
              aria-label={'Quitar ' + tag.text}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    );
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const object = [];
    this.state.tagData.slice(1).forEach((tag) => {
      object.push({
        Mesa: parseInt(tag.id, 10),
        MateriaCarreraCod3: tag.materiaCarreraCod3,
        InscripcionExamenCondicionInsc: tag.condicion.value,
      });
    });

    const { data } = await constantClass.apiFetch('api/ie/multiple', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoxCarreraCod: this.state.alumno.codigo,
        Mesas: object,
        IgnorarCorrelatividad: this.state.ignorarCorrelatividad,
        IgnorarRegularidad: this.state.ignorarRegularidad,
        IgnorarDosDias: this.state.ignorarDosDias,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      const error = data.errorMessage ? data.errorMessage : 'Forbidden.';
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(data, error),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-ie" />;
    }

    const {
      loading,
      errorMessage,
      alumno,
      carreraCursada,
      showLookupAnios,
      showCursada,
      ignorarCorrelatividad,
      ignorarRegularidad,
      ignorarDosDias,
    } = this.state;
    const isBusy = loading;
    const canPickMesa = carreraCursada !== -1;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ie">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Inscripción a Examen</h1>
        <p className="md-form-page__subtitle">
          Seleccione el alumno y una o más mesas de examen. Cada materia puede inscribirse con una condición distinta.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <InscripcionExamenErrorMessage message={errorMessage} /> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando inscripción, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowAniosLookup}
                disabled={isBusy}
              >
                Seleccione el Alumno
              </button>
              {showLookupAnios ? (
                <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.descripcion}
                placeholder="Alumno seleccionado"
                readOnly
                disabled
                aria-label="Alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Mesas de Examen</span>
              {canPickMesa ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCursadaLookup}
                  disabled={isBusy}
                >
                  Seleccione la Mesa de Examen
                </button>
              ) : (
                <p className="md-form-page__empty-hint">Seleccione el Alumno antes de elegir la Mesa de Examen.</p>
              )}
              {showCursada ? (
                <LookupMesaExamen
                  carreraCod={carreraCursada}
                  selectItem={this.handleSelectCursadaItem}
                  hideLookup={this.handleHideLookup1}
                />
              ) : null}
              {this.renderMesaTags()}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="ie-ignorar-correlatividad">
                <input
                  id="ie-ignorar-correlatividad"
                  type="checkbox"
                  checked={ignorarCorrelatividad}
                  onChange={this.handleCheckBoxCorrelatividad}
                  disabled={isBusy}
                />
                {' '}Ignorar verificación de correlatividad
              </label>
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="ie-ignorar-regularidad">
                <input
                  id="ie-ignorar-regularidad"
                  type="checkbox"
                  checked={ignorarRegularidad}
                  onChange={this.handleCheckBoxRegularidad}
                  disabled={isBusy}
                />
                {' '}Ignorar verificación de regularidad
              </label>
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="ie-ignorar-dos-dias">
                <input
                  id="ie-ignorar-dos-dias"
                  type="checkbox"
                  checked={ignorarDosDias}
                  onChange={this.handleCheckBoxDosDias}
                  disabled={isBusy}
                />
                {' '}Ignorar verificación de dos materias por día
              </label>
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
